import { TerminateWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('Terminate')
export class TerminateNodeSchemaProvider extends SchemaProvider<TerminateWorkflowNode> {}
